import React, { memo, useEffect, useState } from 'react';
import useActiveBanners from '../../hooks/useActiveBanners/useActiveBanners';
import ImpersonateBanner from './ImpersonateBanner';
import InfoBanner from './InfoBanner';
import NotificationBanner from './NotificationBanner';

function TopBanner() {
  const BANNER_ID = 'SHOW_PRIVACY_POLICY_BANNER';
  const isImpersonatingAdmin = sessionStorage.getItem('impersonateId') !== null;
  const [isVisible, setIsVisible] = useState(localStorage.getItem(BANNER_ID) !== 'false' || isImpersonatingAdmin);
  const { activeBanners, fetchActiveBanners } = useActiveBanners();

  useEffect(() => {
    fetchActiveBanners();
  }, []);

  /**
   * Close button handler
   */
  const closeBanner = () => {
    localStorage.setItem(BANNER_ID, String(false));
    setIsVisible(false);
  };

  /**
   * Verifies which banners should be rendered
   */
  const renderBanner = () => (isImpersonatingAdmin ? <ImpersonateBanner /> : <InfoBanner onClose={closeBanner} />);

  return (
    <div>
      {isVisible ? renderBanner() : null}
      {activeBanners.map((banner) => (
        <NotificationBanner key={banner.id} banner={banner} />
      ))}
    </div>
  );
}

export default memo(TopBanner);
